import WarningIcon from '@mui/icons-material/Warning';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import { DialogProps } from '@toolpad/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const KEY_WORD = 'REMOVE';
export function DeleteDialog({ open, onClose, title, description, description2 }: DialogProps<null, boolean> & { title: string; description: string; description2: string }) {
    const { t } = useTranslation();
    const [inputValue, setInputValue] = useState('');
    const [saving, setSaving] = useState(false);

    const validateInputs = () => {
        if (inputValue === KEY_WORD) {
            return true;
        }

        return false;
    };

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        event.stopPropagation();

        setSaving(true);
        await onClose(true);
        setSaving(false);
    };

    return (
        <Dialog open={open} fullWidth onClose={() => onClose(false)}>
            <Box component='form' onSubmit={handleSubmit} noValidate>
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                        <Box sx={{ display: 'flex', gap: 2, m: 2 }}>
                            <WarningIcon color='warning' sx={{ alignSelf: 'center' }} />
                            <Box>
                                <Typography>{description}</Typography>
                                <Typography>{description2}</Typography>
                            </Box>
                        </Box>
                        <Box>
                            <Typography variant='body1' gutterBottom>
                                {t('dialog.delete.description')}
                            </Typography>
                            <TextField value={inputValue} label={undefined} onChange={(e) => setInputValue(e.target.value)} fullWidth placeholder={t('dialog.delete.enterKeyword')} />
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button
                        aria-label='dialogue-close'
                        onClick={() => {
                            onClose(false);
                        }}
                    >
                        {t('common.cancel')}
                    </Button>
                    <Button loading={saving} color='error' variant='contained' type='submit' onClick={validateInputs} disabled={inputValue !== KEY_WORD}>
                        {t('dialog.delete.title')}
                    </Button>
                </DialogActions>
            </Box>
        </Dialog>
    );
}
